/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Popups
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.Popups || {};

	var renderPopupTemplate = function( $trigger, mfpResponse ) {
		var template = wp.template( 'astoundify-modal' );

		// try and get some data
		var id = $trigger.data( 'id' ) ? $trigger.data( 'id' ) : 'default';
		var style = $trigger.data( 'style' ) ? $trigger.data( 'style' ) : 'default';
		var type = $trigger.data( 'type' ) ? $trigger.data( 'type' ) : 'light';
		var title = $trigger.data( 'title' );
		var subtitle = $trigger.data( 'subtitle' );
		var content = '';

		if ( mfpResponse.type && 'inline' === mfpResponse.type ) {
			content = $( mfpResponse.data.src ).html();
		} else {
			content = mfpResponse.data;

			// on a "normal" page look for some other existing page content
			if ( $( $.parseHTML( content ) ).find( '[role="main"]' ).length ) {
				content = $( content ).find( '[role="main"]' ).html();

				if ( ! title ) {
					title = $( mfpResponse.data ).find( '.entry-title' ).html();
				}
				
				if ( ! subtitle ) {
					subtitle = $( mfpResponse.data ).find( '.subheadline' ).html();
				}
			}
		}

		return template( {
			id: id,
			style: style,
			type: type,
			title: title,
			subtitle: subtitle,
			content: content
		} );
	};

	/**
	 * Open a popup with some default arguments.
	 *
	 * @since 1.0.0
	 */
	self.open = function( trigger, args ) {
		var $trigger = trigger;

		return $.magnificPopup.open( $.extend( true, args, {
			fixedBgPos: true,
			alignTop: true,
			tLoading: '<img src="' + Astoundify.assetUri + '/images/graphic-loading--dark.gif" width="32px" height="32px" alt="Loading..." />',
			closeMarkup: '<button aria-title="Close" type="button" class="mfp-close">Cancel</button>',
			mainClass: 'mfp-fade',
			items: {
				src: trigger.attr( 'href' )
			},
			callbacks: {
				beforeOpen: function() {
					$( '.edd_errors' ).remove();

					// dont focus on any form elements
					this.st.focus = false;
				},
				elementParse: function( item ) {
					if ( 'inline' === item.type ) {
						item.src = $( renderPopupTemplate( $trigger, item ) );
					}

					return item;
				},
				parseAjax: function( mfpResponse ) {
					mfpResponse.data = renderPopupTemplate( $trigger, mfpResponse );
					return mfpResponse;
				}
			}
		} ) );
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		/**
		 * AJAX Popup
		 *
		 * AJAX popups do not open on mobile devices. 
		 * They direct to their normal pages.
		 *
		 * @see http://dimsemenov.com/plugins/magnific-popup/
		 */
		$( '.js-trigger-popup--ajax' ).on( 'click', function(e) {
			if ( Astoundify.MobileDetect.mobile() && ! $(this).data( 'force-popup' ) ) {
				return true;
			}

			e.preventDefault();

			return self.open( $(this), {
				items: {
					type: 'ajax'
				}
			});
		});

		/**
		 * Inline Popup
		 *
		 * @see http://dimsemenov.com/plugins/magnific-popup/
		 */
		$( '.js-trigger-popup' ).on( 'click', function(e) {
			e.preventDefault();

			return self.open( $(this) );
		});

	});

	/**
	 * Wrap selects on AJAX popups.
	 *
	 * @since 1.0.0
	 */
	$(document).on( 'Astoundify.Popups.Open', function() {
		Astoundify.Select.wrap();
	});

})( jQuery );
